import { injectIntl } from "react-intl";
import { Formik } from "formik";
import { intlShape } from "../../shapes";
import {
  withApi,
  apiShape,
  withBackend,
  backendShape,
  withBrowser,
  browserShape,
  notifierShape,
  withNotifier,
} from "../../context";
import { scaleImageFile } from "../../utils/imageUtils";

import { Form, TextArea, TextInput, SubmitButton, CancelButton } from "../Form";

import { Container, Row, Column } from "../Grid";

import Heading from "../Heading";
import FilesUpload from "../Files/FilesUpload";
import FilesUploadList from "../Files/FilesUploadList";
import BackButton from "../BackButton";

type Props = {
  api: apiShape;
  intl: intlShape;
  browser: browserShape;
  backend: backendShape;
  notifier: notifierShape;
};

export function TicketCreate({ api, backend, browser, notifier, intl }: Props) {
  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    return (
      <Form id="ticket-form" {...formProps}>
        <TextInput
          {...formProps}
          id="ticket-subject"
          label={intl.formatMessage({ id: "label.subject" })}
          disabled={isSubmitting}
          name="subject"
          required
          autoFocus
        />
        <TextArea
          {...formProps}
          id="ticket-description"
          label={intl.formatMessage({ id: "label.description" })}
          disabled={isSubmitting}
          name="description"
          required
          cols={50}
          rows={5}
        />
        <FilesUploadList
          {...formProps}
          filesUploadNameReference="filesUpload"
          uploading={isSubmitting}
        />
        <FilesUpload
          {...formProps}
          id="attachment-upload"
          name="filesUpload"
          multiple
          buildInWhiteList="image/*, video/*, .pdf, .zip"
          fileSizeLimit={1024 * 1024 * 10}
          dropzoneInfoPrefix="add_attachment"
        />
        <div className="btn-group">
          <SubmitButton
            id="ticket-create-submit"
            fetching={isSubmitting}
            disabled={!formProps.dirty}
          />
          <CancelButton
            id="ticket-create-cancel"
            fetching={isSubmitting}
            // @ts-expect-error TS(2322) FIXME: Type '{ id: string; fetching: any; intl: intlShape... Remove this comment to see the full error message
            intl={intl}
          />
        </div>
      </Form>
    );
  };

  const validateForm = (values: $TSFixMe) => {
    const errors = {};
    if (values.subject?.length > 255) {
      (errors as $TSFixMe).subject = intl.formatMessage(
        { id: "validation.subject.too_long" },
        { characters: 255 },
      );
    }
    if (!values.subject || !values.subject?.trim()) {
      (errors as $TSFixMe).subject = intl.formatMessage({
        id: "validation.subject.mandatory",
      });
    }
    if (!values.description || !values.description?.trim()) {
      (errors as $TSFixMe).description = intl.formatMessage({
        id: "validation.description.mandatory",
      });
    }
    return errors;
  };

  async function uploadFiles(ticketId: $TSFixMe, files: $TSFixMe, index = 0) {
    try {
      const compressedFile = await scaleImageFile(files[index], 1200, 0.8);
      await backend.upload(`/support/tickets/${ticketId}/attachments`, {
        name: files[index].name,
        file: compressedFile,
      });
      if (files.length > index + 1) {
        await uploadFiles(ticketId, files, index + 1);
      }
    } catch {
      notifier.showError(
        intl.formatMessage({
          id: "support.ticket.attachments.error_notification",
        }),
      );
    }
  }

  const onSubmit = async (values: $TSFixMe, actions: $TSFixMe) => {
    actions.setSubmitting(true);
    const { subject, description, filesUpload } = values;
    try {
      const response = await backend.post("/support/tickets", {
        subject,
        description,
      });
      if (filesUpload?.acceptedFiles.length > 0) {
        await uploadFiles(response.id, filesUpload.acceptedFiles);
      }
      notifier.showSuccess(
        intl.formatMessage({
          id: "support.ticket.create.success_notification",
        }),
      );
      browser.navigateTo("/support/tickets");
    } catch (error) {
      notifier.showError(api.translateError(error));
    }
    actions.setSubmitting(false);
  };

  return (
    <Container>
      <Row>
        <Column>
          <BackButton />
        </Column>
      </Row>
      <Row>
        <Column>
          <Heading title="Ticket Create" />
          <Formik
            validate={validateForm}
            onSubmit={onSubmit}
            validateOnBlur={false}
            initialValues={{}}
          >
            {renderForm}
          </Formik>
        </Column>
      </Row>
    </Container>
  );
}

export default injectIntl(
  withBackend(withBrowser(withNotifier(withApi(TicketCreate)))),
);
